exports = module.exports = require("../../../node_modules/.pnpm/registry.npmmirror.com+css-loader@0.28.7/node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".nav-left .logo {\n  padding: 30px 0;\n  background-color: #002140;\n  text-align: center;\n}\n.nav-left .logo img {\n  height: 35px;\n}\n.nav-left .logo h1 {\n  color: #ffffff;\n  font-size: 20px;\n  display: inline-block;\n  vertical-align: middle;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/.pnpm/registry.npmmirror.com+css-loader@0.28.7/node_modules/css-loader?{"importLoaders":1}!./node_modules/.pnpm/registry.npmmirror.com+postcss-loader@2.0.8/node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./node_modules/.pnpm/registry.npmmirror.com+less-loader@4.1.0_less@2.7.3+webpack@3.8.1/node_modules/less-loader/dist/cjs.js!./src/components/NavLeft/index.less
// module id = 545
// module chunks = 20